import React, {useCallback, memo} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AppSpinner from './AppSpinner';
import { Tooltip } from 'react-tooltip';
import { timeseriesAPI, graphPrioEventsAPI, graphDeploymentEventsAPI } from "../http-common";                                                    // Deconstruct der benötigten API
import { createTicketAPI } from '../http-common';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import exportAsImage from './exportAsImage';
import Popup from 'reactjs-popup';


import '../styles/SingleGraph.css';

// Globale Highcharts Optionen
Highcharts.setOptions({
  // Highcharts v12: `global.useUTC` ist deprecated und wandert in den
  // `time`-Namespace. Statt Browser-Locale-Abhängigkeit setzen wir die
  // Zeitzone explizit auf Europe/Berlin – Sommer-/Winterzeit wird über die
  // native `Intl.DateTimeFormat`-API automatisch aufgelöst. Deterministisch
  // unabhängig von OS-/Container-Zeitzone.
  time: {
    timezone: 'Europe/Berlin'
  },
  // Highcharts v12 hat das Default-Tooltip-Theme geändert (dunkler Hintergrund,
  // hellgrauer Text). Im Stock-Chart-Split-Modus rendert v12 zudem jede
  // Series in einem eigenen Kästchen mit dem GLOBALEN Style – per-Series
  // `backgroundColor`/`style` werden ignoriert. Daher den finalen Look hier
  // einmal global definieren (weißer Hintergrund, dunkler Text), damit
  // Datum-Header UND jede Series-Box einheitlich lesbar sind.
  tooltip: {
    backgroundColor: '#FFFFFF',
    borderColor: '#CCCCCC',
    borderRadius: 10,
    borderWidth: 1,
    style: {
      color: '#333333',
      fontSize: '11px'
    }
  },
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    loading: 'Daten werden geladen...',
    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    exportButtonTitle: "Exportieren",
    printButtonTitle: "Drucken",
    rangeSelectorFrom: "Von",
    rangeSelectorTo: "Bis",
    rangeSelectorZoom: "Zeitraum",
    downloadPNG: 'Download als PNG-Bild',
    downloadJPEG: 'Download als JPEG-Bild',
    downloadPDF: 'Download als PDF-Dokument',
    downloadSVG: 'Download als SVG-Bild',
    resetZoom: "Zoom zurÃ¼cksetzen",
    resetZoomTitle: "Zoom zurÃ¼cksetzen"
  }
});

const SingleGraph = (props) => {

    //console.log(props)
    const endpointURL = "/"+ props.productID +"/tests/"+ props.testID +"/performance?grouped=true"
    const eventURL = "/"+ props.productID +"/tests/"+ props.testID +"/performance/events"
    
    
    /***
     *     __  ___      ___  ___  __  
     *    /__`  |   /\   |  |__  /__` 
     *    .__/  |  /~~\  |  |___ .__/ 
     *                                
     */
    const [isLoaded, setIsLoaded] = React.useState(false);                                       // Indikator ob Daten geladen wurden.       
    const [hasError, setHasError] = React.useState(false);                                       // Indikator ob Fehler vorliegen
    const errMessage = "Nothing to see"
    const [options, setOptions] = React.useState(null);                                          // Options holds the options for the Highcharts
    const [width, setWidth] = React.useState(0);
    const [height, setHeight] = React.useState(0);
    const [showTicketModal, setShowTicketModal] = React.useState(false);
    const [ticketIssueType, setTicketIssueType] = React.useState("service")
    
    const ref = React.useRef();
    const seriesCount = React.useRef(0);
    const prioCount = React.useRef(0);
    const deploymentCount = React.useRef(0);
    
    //console.log("Graph: " + props.testID + " re-rendered!")
    
    /***
     *          __   ___     ___  ___  ___  ___  __  ___  __  
     *    |  | /__` |__     |__  |__  |__  |__  /  `  |  /__` 
     *    \__/ .__/ |___    |___ |    |    |___ \__,  |  .__/ 
     *                                                        
     */
    

    const fetchData = async () => {

      const idToken = await props.receiveAccessToken();
      //const idToken = props.receiveIDToken();
      const headers = { 'Authorization': idToken };  
      const res = await timeseriesAPI.get(endpointURL, {headers});

      const prioEvents = await graphPrioEventsAPI.get(eventURL + "?detailedString=false&type=prio_issue", {headers})
      .then(response => {
        
        if(props.showPrioFlags === true){
          let obj = {
            data:  response.data
          };
          return obj
        } else {
          let obj = {
            data:  []
          };
          return (obj)          
        }        
      })
      .catch(function (error) {
        //console.log("Fetch error prio events" +error)
        //props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der Flags: Priostörungen"})
        let obj = {
          data:  []
        };
        return (obj)
      });

      //console.log("prioevents:")
      //console.log(prioEvents)

      const deploymentEvents = await graphDeploymentEventsAPI.get(eventURL + "?detailedString=false&type=deployment", {headers})
      .then(response => {
        if(props.showDeploymentFlags === true){
          let obj = {
            data:  response.data
          };
          return obj
        } else {
          let obj = {
            data:  []
          };
          return (obj)          
        }        
      })
      .catch(function (error) {
        console.log("Fetch error deployment events" + error)
        //props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der Flags: Deployments"})
        let obj = {
          data:  []
        };
        return (obj)
      });
    
      //console.log("Loaded Prio:")
      //console.log(prioEvents.data)

      //console.log(res)      
      const result = {
          status: res.status + "-" + res.statusText,
          headers: res.headers,
          data: res.data,
          prio: prioEvents.data,
          deployments: deploymentEvents.data          
      };

      /*
      console.log("PrioData:")
      console.log(result.prio)
      console.log("deployments:")
      console.log(result.deployments)
      */
      
      return result
    }



    React.useEffect(() => {
      setIsLoaded(false);        
      let timeseriesInterval

      const fetchRecords = async () => {
          //console.log("Fetching Timeseries data..." + timeseriesAPI)
          const idToken = await props.receiveAccessToken();
          //const idToken = props.receiveIDToken();          
          const headers = { 'Authorization': idToken };
          const res = await timeseriesAPI.get(endpointURL, {headers});

          const prioEvents = await graphPrioEventsAPI.get(eventURL + "?detailedString=false&type=prio_issue", {headers})
          .then(response => {
            //console.log(response)
            if(props.showPrioFlags === true){
              let obj = {
                data:  response.data
              };
              return obj
            } else {
              let obj = {
                data:  []
              };
              return (obj)          
            }        
          })
          .catch(function (error) {
            //console.log("Fetch error prio events" +error)
            //props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der Flags: Priostörungen"})
            let obj = {
              data:  []
            };
            return (obj)
          });          

          //detailed:true/false
          // prio_issue

          const deploymentEvents = await graphDeploymentEventsAPI.get(eventURL + "?detailedString=false&type=deployment", {headers})
          .then(response => {
            if(props.showDeploymentFlags === true){
              let obj = {
                data:  response.data
              };
              return obj
            } else {
              let obj = {
                data:  []
              };
              return (obj)          
            }        
          })          
          .catch(function (error) {
            //console.log("Fetch error deployment events" + error)
            //props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der Flags: Deployments"})
            let obj = {
              data:  []
            };
            return (obj)
          });
          
          const result = {
              status: res.status + "-" + res.statusText,
              headers: res.headers,
              data: res.data,
              prio: prioEvents.data,
              deployments: deploymentEvents.data
          };

          // Hard-Floor fuer die "< X -> immer rot"-Zone. Werte unter diesem
          // Schwellenwert gelten als Ausfall/kein-Messwert und werden rot dargestellt,
          // unabhaengig von den user-editierbaren thresholds. Passt sowohl fuer AWS
          // (0/1-Metrik) als auch fuer synthetic (Ausfall = 0s). Wert bewusst identisch
          // zur AWS-Zonen-Grenze, damit die 0-Erkennung konsistent bleibt.
          const HARD_MIN_THRESHOLD = 0.005;

          const minCrit = props.thresholds.okay;
          const warn = props.thresholds.warn;
          const crit = props.thresholds.crit;
          // Wenn User minCrit (thresholds.okay) auf 0 oder leer setzt, auf HARD_MIN_THRESHOLD
          // hochziehen. Damit bleibt die Zone-Sortierung [HARD_MIN_THRESHOLD, effectiveMinCrit, warn, crit]
          // aufsteigend und Highcharts rendert die Zonen korrekt.
          const effectiveMinCrit = Math.max(Number(minCrit) || 0, HARD_MIN_THRESHOLD);
          const graphTitel = null;
          const subTitel = null;            
          const graphEinheit = 'sek.';
          const PlotLabelColor = 'var(--PlotLabelColorCustom)';
          let defaultTimerange = 0;

          switch(props.handleGraphDefaultTimerange) {
            case '6h':
              defaultTimerange = 0
              break;
            case '12h':
              defaultTimerange = 1
              break;
            case '1d':
              defaultTimerange = 2
            break;
            case '1w':
              defaultTimerange = 3
            break;
            case '3w':
              defaultTimerange = 4
            break;
            case 'all':
              defaultTimerange = 5
            break;                              
            default:
              defaultTimerange = 0
          } 

          // y=0 (Ausfall/CRIT) auffaellig hervorheben: pro Datenpunkt einen roten
          // Kreis-Marker ueberschreiben. Highcharts akzeptiert im data-Array sowohl
          // Tupel [x, y] als auch Punkt-Objekte { x, y, marker, ... }.
          const zeroPointMarker = {
              enabled: true,
              radius: 3,
              fillColor: '#df002e',
              lineWidth: 0,
              symbol: 'circle'
          };
          const enhancedData = (result.data || []).map(function(point){
              if(Array.isArray(point)){
                  if(point[1] === 0){
                      return { x: point[0], y: 0, marker: zeroPointMarker };
                  }
                  return point;
              }
              if(point && typeof point === 'object' && point.y === 0){
                  return { ...point, marker: zeroPointMarker };
              }
              return point;
          });

          /// Setting the Highstock options variable
          setOptions({
            
            title: {
              text: graphTitel,
              style: {
                color: 'white',
                fontWeight: 'bold'
              }
            },

            subtitle: {
                text: subTitel,
                style: {
                    color: 'white',
                }
            },

            scrollbar: {
              barBackgroundColor: 'var(--subtext-color)',
              barBorderRadius: 5,
              barBorderWidth: 0,
              buttonBackgroundColor: 'var(--subtext-color)',
              buttonBorderWidth: 0,
              buttonBorderRadius: 5,
              trackBackgroundColor: 'var(--hover-color)',
              trackBorderWidth: 0,
              trackBorderRadius: 6,
              trackBorderColor: '#CCC'
            },

            // AWS: Navigator (untere Uebersicht) explizit konfigurieren, damit die
            // dortige Series bei starker Aggregation nicht auf gemittelte Zwischenwerte
            // rutscht und die roten y=0-Marker aus enhancedData nicht falsch positioniert
            // werden. Fuer synthetic bleibt der Default (approximation:'average' + Marker
            // laut per-point Overrides).
            navigator: {
                series: {
                    dataGrouping: {
                        approximation: props.origin === 'AWS' ? 'low' : undefined
                    },
                    marker: {
                        enabled: props.origin === 'AWS' ? false : undefined
                    }
                }
            },

            chart: {
              zoomType: 'x',
              backgroundColor: 'transparent',
              reflow: true,
              
            events: {
                load: function () {
                    //console.log("Updating Graph  data...") 
                    
                    let series = this.series[0];
                    let prioSeries = this.series[1];
                    let deploymentSeries = this.series[2]; 
                    // Highcharts v12: `series.xData`/`yData` sind nicht mehr
                    // öffentlich gepflegt (lazy getter über `series.getColumn`).
                    // Für einen reinen Count reicht `series.data.length`, was
                    // für die anderen beiden Serien hier ohnehin schon genutzt
                    // wird.
                    seriesCount.current = series.data.length;
                    prioCount.current = prioSeries.data.length;
                    deploymentCount.current = deploymentSeries.data.length; 
                    /*
                    console.log("Series: ")
                    console.log(series)
                    console.log("Prio: ")
                    console.log(prioSeries)                    
                    console.log("Series current: " + seriesCount.current)
                    console.log("Prio current: " + prioCount.current)
                    console.log("Deployment current: " + deploymentCount.current)
                    */
                    timeseriesInterval = setInterval(function () {
                        fetchData().then(
                          function(value) {
                            /*
                            console.log("value:")
                            console.log(value)
                            
                            console.log("series: ")
                            console.log(series)
        
                            console.log("PrioSeries: ")
                            console.log(prioSeries)
        
                            console.log("deploymentSeries: ")
                            console.log(deploymentSeries)  
                            */

                            //--------------------------------------------
                            // Prüfen ob neue Values des Graphen vorliegen
                            //--------------------------------------------
                            const oldLength = seriesCount.current;
                            //console.log("Series: ")
                            //console.log(series)
                            const newLength = value.data.length;
                            //console.log("Value: ")
                            //console.log(value)                            

                            if(oldLength !== newLength){
                                console.log("Neue Daten für Graphen gefunden.")
                                const newPoints = newLength - oldLength;
                                const newStart = newLength - newPoints;
                                
                                console.log("Old Length: " + oldLength)
                                console.log("New Length: " + newLength)
                                console.log("New Points: " + newPoints)
                                console.log("New Start: " + newStart)
                                
                                if(newPoints < 10){
                                  for(let i = 0; i < newPoints; i++ ){
                                      
                                      let getFrom = newStart;                                    
                                      console.log("Add Data: " + value.data[getFrom])
                                      series.addPoint([value.data[getFrom][0], value.data[getFrom][1]], true, true);
                                      getFrom++

                                  }
                                  seriesCount.current = newLength
                                } else {
                                  console.log("Zuviele neue Messungen. Seite refreshen!")    
                                }

                            } else {
                              //console.log("Keine neuen Daten vorhanden.")
                            }

                            //--------------------------------------------
                            // Prüfen ob neue Daten der Priostörungen vorliegen
                            //--------------------------------------------  
                            
                            const prioOldLength = prioCount.current;
                            const prioNewLength = value.prio.length;

                            /*
                            console.log("PrioOld: ")
                            console.log(prioCount.current) 
                            console.log("PrioNew: " + prioNewLength)
                            */

                            if(prioOldLength !== prioNewLength){
                                console.log("Neue Daten für Priostörungen gefunden.")
                                const prioNewPoints = prioNewLength - prioOldLength;
                                const prioNewStart = prioNewLength - prioNewPoints;

                                if(prioNewPoints < 10){
                                  for(let i = 0; i < prioNewPoints; i++ ){
                                      
                                      let prioGetFrom = prioNewStart;                                    
                                      console.log("Add Prio: " + value.prio[prioGetFrom])
                                      prioSeries.addPoint({x: value.prio[prioGetFrom]['x'] ,title: value.prio[prioGetFrom]['title'],text: value.prio[prioGetFrom]['text']});
                                      prioGetFrom++

                                  }
                                  prioCount.current = prioNewLength
                                } else {
                                  console.log("Zuviele neue Einträge bei den Priostörungen. Seite refreshen!")    
                                }

                            } else {
                              //console.log("Keine neuen Priostörungen vorhanden.")
                            }   
                            
                            //--------------------------------------------
                            // Prüfen ob neue Daten der Deployments vorliegen
                            //--------------------------------------------  
                            
                            const deploymentsOldLength = deploymentCount.current;
                            const deploymentsNewLength = value.deployments.length;

                            if(deploymentsOldLength !== deploymentsNewLength){
                                console.log("Neue Daten für Priostörungen gefunden.")
                                const deploymentsNewPoints = deploymentsNewLength - deploymentsOldLength;
                                const deploymentsNewStart = deploymentsNewLength - deploymentsNewPoints;

                                if(deploymentsNewPoints < 10){
                                  for(let i = 0; i < deploymentsNewPoints; i++ ){
                                      
                                      let deploymentsGetFrom = deploymentsNewStart;                                    
                                      console.log("Add Deployment: " + value.deployments[deploymentsGetFrom])
                                      deploymentSeries.addPoint({x: value.deployments[deploymentsGetFrom]['x'] ,title: value.deployments[deploymentsGetFrom]['title'],text: value.deployments[deploymentsGetFrom]['text']});
                                      deploymentsGetFrom++

                                  }
                                  deploymentCount.current = deploymentsNewLength
                                } else {
                                  console.log("Zuviele neue Einträge bei den Deployments. Seite refreshen!")    
                                }

                            } else {
                              //console.log("Keine neuen Deployments vorhanden.")
                            }                             
                          },
                          function(error) {
                            console.log("Error beim Updaten des Graphen")
                            console.log(error)
                            setHasError(true)
                          }
                        )                        

                    }, 10000);

                }
              }
              
            },

            yAxis: [{
              opposite:false,															              // Linke Seite für die Label festlegen
              gridLineColor: 'rgba(128,128,128,0.22)',
              gridLineDashStyle: 'ShortDash',
              gridLineWidth: 1,
              tickWidth: 0,
              labels: {
                  formatter: function() {
                    // AWS/Cloudwatch: 0/1-Zustand → statt "0 sek." / "1 sek." lesbare
                    // Status-Labels. Andere Zwischenwerte kommen praktisch nicht vor,
                    // werden aber sicherheitshalber unformatiert durchgereicht.
                    if(props.origin === 'AWS'){
                      if(this.value === 0) return 'CRIT';
                      if(this.value === 1) return 'OK';
                      return this.value;
                    }
                    return this.value + ' ' + graphEinheit;							// Übergebene Einheit
                  },
                  style: {
                    color: PlotLabelColor
                  }
              },

              title: {
                  text: props.origin === 'AWS' ? 'Cloudwatch Alarm Status' : 'Durchlaufzeit in ' + graphEinheit,
              },

              // AWS: keine dynamischen threshold-Linien (warn/crit) — die Werte sind 0/1
              // und werden im Backend zwar mitgepflegt, ergeben aber keinen sinnvollen
              // Sekunden-Grenzwert. Fuer synthetic bleiben die klassischen Marker-Linien.
              plotLines: props.origin === 'AWS' ? [] : [{
                  color: '#f5a524', 														        // Color value
                  dashStyle: 'shortdash', 												      // Style of the plot line. Default to solid
                  value: warn, 															            // Value of where the line will appear
                  width: 1, 																            // Width of the line
                  label: {
                      text: 'Warnung: ' + warn + ' ' + graphEinheit,		// Content of the label.
                      align: 'left', 														        // Positioning of the label.
                      style: {
                          color: PlotLabelColor,												// Fontcolor
                          'font-size': 'xx-small'
                      }
                  }
              },{
                  color: '#ea5252', 														        // Color value
                  dashStyle: 'shortdash', 												      // Style of the plot line. Default to solid
                  value: crit,															            // Value of where the line will appear
                  width: 1, 																            // Width of the line
                  label: {
                      text: 'Kritisch: ' + crit + ' ' + graphEinheit,		// Content of the label.
                      align: 'left', 														        // Positioning of the label.
                      style: {
                          color: PlotLabelColor,												// Fontcolor
                          'font-size': 'xx-small'
                      }
                  }
              }]
            }],


            xAxis: [{
              gridLineWidth: 0,
              minorGridLineWidth: 0,
              tickWidth: 0,
              // AWS/Cloudwatch: proportionale Zeitachse. Highstock hat als Default
              // ordinal:true (Punkte gleich weit auseinander unabhaengig vom Zeitstempel
              // — gedacht fuer Aktien mit Wochenend-Luecken). Fuer AWS-Metriken willen
              // wir aber sehen, dass zwischen Messpunkten wirklich 5 oder 10 Minuten
              // liegen (und Luecken sichtbar sind). Synthetic behaelt Default-Verhalten.
              ordinal: props.origin === 'AWS' ? false : undefined,
              
              labels: {
                style: {
                  color: PlotLabelColor
                }
              },
            }],


            rangeSelector: {
                buttonTheme: { 
                  fill: 'none',
                  stroke: 'none',
                  'stroke-width': 0,
                  r: 8,
                  style: {
                      color: 'var(--subtext-color)',
                      fontWeight: 'bold',
                      fontSize: '11px'
                  },
                  states: {
                      hover: {
                        fill: 'var(--hover-color)',
                          style: {
                              color: 'white'
                          }
                      },
                      select: {
                          fill: 'var(--hover-color)',
                          style: {
                              color: 'white'
                          }
                      }
                  }
                },
                inputStyle: {
                  color: 'var(--subtext-color)',
                  fontWeight: 'bold',
                  fontSize: '11px'
                },

                selected: defaultTimerange,
                inputEnabled: true,
                inputDateFormat: '%d.%m.%Y',
                buttons: [{
                    type: 'hour',
                    count: 6,
                    text: '6h',
                    events: {
                        click: function() {

                        }
                    }
                },{
                    type: 'hour',
                    count: 12,
                    text: '12h',
                    events: {
                        click: function() {

                        }
                    }
                },{
                    type: 'day',
                    count: 1,
                    text: '1d',
                    events: {
                        click: function() {

                        }
                    }
                },{
                    type: 'week',
                    count: 1,
                    text: '1w',
                    events: {
                        click: function() {

                        }
                    }
                },{
                    type: 'week',
                    count: 3,
                    text: '3w',
                    events: {
                        click: function() {

                        }
                    }
                },{
                    type: 'all',
                    text: 'All'
                }]
            },    


            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: false
                    }
                },
                series: {
                  lineWidth: 2,
                  // AWS: 0-preserving dataGrouping-Approximation — wirkt auch auf die
                  // Navigator-Series (untere Gesamtübersicht), weil die keinen eigenen
                  // dataGrouping-Block hat und daher von plotOptions erbt. Sobald ein
                  // Rohwert im Bucket 0 ist, wird das Bucket-Aggregat 0 — rote Marker
                  // sitzen dann exakt auf y=0 statt am gemittelten Zwischenwert.
                  // Fuer synthetic: undefined = Highstock-Default (average).
                  dataGrouping: {
                    approximation: props.origin === 'AWS' ? function(values){
                        if(!values || !values.length) return null;
                        for(let i = 0; i < values.length; i++){
                            if(values[i] === 0) return 0;
                        }
                        let sum = 0;
                        for(let i = 0; i < values.length; i++){ sum += values[i]; }
                        return sum / values.length;
                    } : undefined
                  }
                }
            },

            series: [
                {
                    name : 'Antwortzeit',
                    turboThreshold: 11000,
                    data: enhancedData,
                    id: 'dataseries',
                    // AWS/Cloudwatch-Metriken sind binaere 0/1-Zustaende; deshalb Stufenlinie
                    // (90-Grad-Uebergaenge) statt der Default-Interpolation zwischen Punkten.
                    // Synthetische Graphen behalten die klassische Linien-Darstellung.
                    step: props.origin === 'AWS' ? 'left' : undefined,

                    zones: props.origin === 'AWS' ? [
                      // AWS/Cloudwatch: nur 2 Zonen — rot bei 0 (CRIT), gruen bei 1 (OK).
                      // Die dynamischen thresholds (okay/warn/crit) werden hier bewusst
                      // ignoriert, da sie fuer eine 0/1-Metrik keinen sinnvollen Verlauf ergeben.
                      { value: 0.005, color: '#df002e' },
                      { color: '#84bc34' }
                    ] : [{															      // Festlegen in welchen Bereichen Alarmiert wird
                      // Hard-Floor: Werte < HARD_MIN_THRESHOLD (0.005) werden immer rot
                      // dargestellt, unabhaengig von den dynamischen thresholds. Fuer
                      // synthetic markiert es Ausfaelle (Test nicht durchgelaufen bzw.
                      // keine gueltige Messung).
                      value: HARD_MIN_THRESHOLD,
                      color: '#df002e'
                    }, {
                      value: effectiveMinCrit,										// Bei y-Wert bis minCrit = crit (rot); effectiveMinCrit = max(minCrit, HARD_MIN_THRESHOLD)
                      color: '#df002e'
                    },{
                      value: warn,														  // Bei y-Wert bis warn = warnung (gelb)
                      color: '#84bc34'
                    }, {
                      value: crit,														  // Bei y-Wert ab crit = kritisch (rot)
                      color: '#e6be00'
                    }, {
                      color: '#df002e'													// sonst (grÃ¼n)
                  }],

                  dataGrouping: {
                    // dataGrouping.approximation ist in plotOptions.series definiert,
                    // damit sie auch fuer die Navigator-Series gilt (siehe oben).
                    dateTimeLabelFormats: {
                        millisecond: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                        second: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                        minute: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                        hour: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                        day: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                        week: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                        month: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                        year: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M']
                    }
                },

                marker: {
                  symbol: 'circle',
                  states: {
                      hover: {
                          fillColor: 'white',
                          lineColor: 'white',
                          lineWidth: 3
                      }
                  }
                },

                shadow: false,
                tooltip: props.origin === 'AWS' ? {
                    xDateFormat: '%A, %e. %B, %Y %H:%M:%S',
                    // AWS/Cloudwatch-Metriken sind 0/1-Zustaende; statt der synthetischen
                    // "Durchlaufzeit" wird der uebersetzte Status ausgegeben.
                    pointFormatter: function() {
                        const label = this.y === 1 ? 'OK' : 'CRIT';
                        return '<p style="font-size:11px;">Cloudwatch Status: <b>' + label + '</b><br/>';
                    }
                    // Hinweis: backgroundColor/borderColor/borderRadius/borderWidth
                    // sind in Highcharts v12 im Stock-Chart-Split-Modus no-ops;
                    // der Style kommt vom globalen `Highcharts.setOptions({ tooltip: ... })`.
                } : {
                    xDateFormat: '%A, %e. %B, %Y %H:%M:%S',
                    // pointFormatter statt pointFormat, damit y === 0 (Testlauf ohne
                    // gueltige Durchlaufzeit) ein eigener Text bekommt, statt irrefuehrend
                    // "Durchlaufzeit: 0 sek." anzuzeigen.
                    pointFormatter: function() {
                        if(this.y === 0){
                            return '<p style="font-size:11px;">Testlauf fehlgeschlagen<br/>';
                        }
                        return '<p style="font-size:11px;">Durchlaufzeit: <b>' + this.y.toFixed(2) + '</b> ' + graphEinheit + '<br/>';
                    }
                    // Hinweis: backgroundColor/borderColor/borderRadius/borderWidth
                    // sind in Highcharts v12 im Stock-Chart-Split-Modus no-ops;
                    // der Style kommt vom globalen `Highcharts.setOptions({ tooltip: ... })`.
                },               

                },
                {
                  type: 'flags',
                  fillColor: "#5F86B3",
                  cursor: 'pointer',
                  name: 'Flags in pane',
                  data: result.prio,
                  onSeries: 'dataseries',
                  style: { // text style
                      color: 'white',
                      fontSize: '11px'
                  },
                  states: {
                      hover: {
                          fillColor: '#395C84', // darker
                          lineColor: 'white'
                      },
                      normal: {
                          fillColor: '#395C84', // darker
                          lineColor: 'white'
                      }
                  },

                  point: {
                      events: {
                          click: function () {
                              window.open(this.link, '_blank');
                          }
                      }
                  }

                },
                {
                  type: 'flags',
                  fillColor: "#d09344",
                  cursor: 'pointer',
                  name: 'Flags in pane',
                  data: result.deployments,
                  onSeries: 'dataseries',
                  style: { // text style
                      color: '#000000',
                      fontSize: '11px'
                  },
                  states: {
                      hover: {
                          fillColor: '#d09344', // darker
                          lineColor: '#000000'
                      },
                      normal: {
                          fillColor: '#d09344', // darker
                          lineColor: '#000000'
                      }
                  },

                  point: {
                      events: {
                          click: function () {
                              window.open(this.html_url, '_blank');
                          }
                      }
                  }
                }
            ],

            credits: {
                enabled: false
            },

            accessibility: {
              enabled: false
            },

            exporting: {
                enabled: false
            }
          });

          setIsLoaded(true); 



      }

      fetchRecords().catch(function (error) {
        if (error.response) {
          setHasError(true)
          console.log("ERROR! Request made and server responded")
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          setHasError(true)
          console.log("ERROR! The request was made but no response was received")
          console.log(error.request);
        } else {
          setHasError(true)
          console.log("ERROR! Something happened in setting up the request that triggered an Error")
          console.log('Error', error.message);
        }
      })
       
    // Cleanup function on component dismount
    return () => {
      clearInterval(timeseriesInterval);
    };

  }, []);
    
  /**
   * Funktion um den Resize des Parent DIV des Graphen zu detecten
   */
  React.useEffect(() => {
      const observer = new ResizeObserver(([entry]) => {
        setWidth(entry.contentRect.width);
        setHeight(entry.contentRect.height);
        onLayoutChange();
      });
      observer.observe(ref.current);
      onLayoutChange();
      return () => {
        observer.disconnect();
      };
    }, []);      
      
    /***
     *     ___            __  ___    __        __  
     *    |__  |  | |\ | /  `  |  | /  \ |\ | /__` 
     *    |    \__/ | \| \__,  |  | \__/ | \| .__/ 
     *                                             
     */
    const onLayoutChange = () => {
        //console.log("Layout changed!")
        for (let i = 0; i < Highcharts.charts.length; i += 1) {
          if (Highcharts.charts[i] !== undefined) {
            Highcharts.charts[i].reflow(); // here is the magic to update charts' looking
          }
        }
    };
   
    const closeTicketWindow = () => {
      setShowTicketModal(false);  
    }

    const openTicketWindow = () =>  {
      setShowTicketModal(true);  
    }

    const onOptionChange = e => {
      setTicketIssueType(e.target.value)
    }

    const summaryRef = React.useRef();
    const descriptionRef = React.useRef();
    

    const createJiraTicket = async () => {  
            
      exportAsImage(ref.current, "test").then(async function(result) {

        // Ticket JSON erstellen
        const ticketData = JSON.stringify({
          reporter: props.userName,
          product: props.productName,
          summary: summaryRef.current.value,
          description: "Ticket erstellt von: " + props.userName + " -- " + descriptionRef.current.value,
          issue_type: ticketIssueType,
          file: result.src,
        });

        const idToken = await props.receiveAccessToken();
        //const idToken = props.receiveIDToken();
        const headers = { 'Authorization': idToken };
  
        
        createTicketAPI.post("/", ticketData, {headers})
          .then(response => {
            console.log(response);
            props.handleNotify({ type: "infoPerm", message: "Ticket erstellt: " + response.data.key });
            
            let ticketlink = response.data.self
            let pathArray = ticketlink.split( '/' );
            let protocol = pathArray[0];
            let host = pathArray[2];
            let url = protocol + '//' + host + '/browse/' + response.data.key;
            closeTicketWindow();
            
            try {
              window.open(url, '_blank').focus();
            } catch (exceptionVar) {
              console.log("Popup Berechtigungen im Browser nicht gesetzt")
            }
            
          })
          .catch(function (error) {
            console.error(error);
            props.handleNotify({ type: "alert", message: "Ticket erstellen fehlgeschlagen" });
          });          

        });

      }         


      /*
      console.log("User: " + props.userName) 
      console.log("Produkt: " + props.productName) 
      console.log("Test: " + props.testName) 
      console.log("Summary: " + summaryRef.current.value) 
      console.log("Description: " + descriptionRef.current.value)
      console.log("Issue Type: " + ticketIssueType) 
      */
    
    
    

    /***
     *     __   __            __   ___ ___       __       
     *    |  \ /  \  |\/|    |__) |__   |  |  | |__) |\ | 
     *    |__/ \__/  |  |    |  \ |___  |  \__/ |  \ | \| 
     *                                                    
     */

  // Globaler Schlüssel für diese Graph-Instanz (für den Info-Button)
  const graphKey = props.productID + '|' + props.testID;

    return(
        <>
          <Popup open={showTicketModal} closeOnDocumentClick onClose={setShowTicketModal}>
            <div className="ticketModal">
                  <div className="ticketModalHeader">
                    <div className="ticketModalIcon" aria-hidden="true">
                      <FontAwesomeIcon icon="fa-solid fa-ticket" />
                    </div>
                    <div className="ticketModalHeaderText">
                      <div className="ticketModalHeaderMeta">Neues Ticket</div>
                      <div className="ticketModalHeaderTitle">Jira Ticket erstellen</div>
                    </div>
                  </div>

                  <div className="ticketModalBody">

                      <div className="ticketModalStaticContent">
                        <div className="ticketModalStaticRow"><span className="ticketModalStaticLabel">Reporter</span><span className="ticketModalStaticValue">{props.userName}</span></div>
                        <div className="ticketModalStaticRow"><span className="ticketModalStaticLabel">Produkt</span><span className="ticketModalStaticValue">{props.productName}</span></div>
                        <div className="ticketModalStaticRow"><span className="ticketModalStaticLabel">Test</span><span className="ticketModalStaticValue">{props.testName}</span></div>
                      </div>

                      <div className="ticketModalField">
                        <label className="ticketModalLabel" htmlFor="ticket-summary">Ticket Zusammenfassung</label>
                        <input id="ticket-summary" className="ticketModalInput"
                          ref={summaryRef}
                          type="text"
                          name="summary"
                        />
                      </div>

                      <div className="ticketModalField">
                        <label className="ticketModalLabel" htmlFor="ticket-description">Ticket Beschreibung</label>
                        <textarea id="ticket-description" className="ticketModalArea"
                          ref={descriptionRef}
                          name="description"
                          rows="4"
                        />
                      </div>

                      <div className="ticketModalField">
                        <div className="ticketModalLabel">Issue Type</div>
                        <div className="ticketModalRadioGroup" role="radiogroup" aria-label="Issue Type">
                          <label className="ticketModalRadioPill">
                            <input
                              type="radio"
                              value="service"
                              name="tickettype"
                              checked={ticketIssueType === "service"}
                              onChange={onOptionChange}
                            />
                            <span>Service-Auftrag</span>
                          </label>
                          <label className="ticketModalRadioPill">
                            <input
                              type="radio"
                              value="alarm"
                              name="tickettype"
                              checked={ticketIssueType === "alarm"}
                              onChange={onOptionChange}
                            />
                            <span>Alarm</span>
                          </label>
                        </div>
                      </div>

                  </div>

                  <div className="ticketModalActions">
                    <button
                      type="button"
                      className="ticketModalBtn ticketModalBtn--secondary"
                      onClick={() => {
                        closeTicketWindow()
                      }}
                    >
                      Abbrechen
                    </button>
                    <button
                      type="button"
                      className="ticketModalBtn ticketModalBtn--primary"
                      onClick={() => {

                        if(summaryRef.current.value !== "" && descriptionRef.current.value !== ""){
                          props.handleNotify({type: 'info', message: "Das Ticket wird erstellt. Bitte warten..."})
                          createJiraTicket()
                        } else {
                          props.handleNotify({type: 'alert', message: "Es muss sowohl eine Zusammenfassung als auch eine Beschreibung eingegeben werden!"})
                        }

                      }}
                    >
                      Speichern
                    </button>
                  </div>
                </div>
          </Popup> 
          <div className="singleGraphContainer" ref={ref}>
            <div className="singleGraph--HeaderContainer" onClick={onLayoutChange}>
                {(() => {
                    // 3-Buchstaben-Label pro Origin. Wenn spaeter neue graph-faehige Origins
                    // dazu kommen, hier ergaenzen.
                    const originLabel = props.origin === 'AWS'
                        ? 'AWS'
                        : (typeof props.origin === 'string' && props.origin.startsWith('synthetic')) ? 'SYN' : null;
                    if(!originLabel) return null;
                    return <div className={"singleGraph--HeaderOriginTag singleGraph--HeaderOriginTag--" + originLabel}>{originLabel}</div>;
                })()}
                <div className="singleGraph--HeaderTextContainer">
                    <div className="singleGraph--HeaderTextProduct"><div>{props.productName}</div></div>
                    <div className="singleGraph--HeaderTextTest"><div>{props.testName}</div></div>
                </div>
                <div className="singleGraph--HeaderMiddle"></div>
                {/*
                <div id={"tooltip-refresh"} className="singleGraph--HeaderToolBtn" onClick={() => props.handleNotify({type: 'info', message: "TODO: Sobald der Daten Refresh durch die QS ist: Graphrefresh " + props.testID})}><FontAwesomeIcon icon="fa-solid fa-rotate" /></div>
                <Tooltip    
                    className="tooltipStyles"
                    anchorSelect={"#tooltip-refresh"} 
                    html={"Graphdaten aktualisieren"} 
                    place="bottom" 
                />
                */}
                <div className="singleGraph--HeaderToolBtnGroup">
                {props.origin === 'AWS' ? (
                  <>
                    <div
                      id={"tooltip-awslink"}
                      className="singleGraph--HeaderToolBtn"
                      onClick={() => {
                        if(props.url){
                          window.open(props.url, '_blank').focus();
                        } else if(props.handleNotify){
                          props.handleNotify({type: 'warning', message: 'Fuer diesen Test ist keine Verlinkung hinterlegt.'});
                        }
                      }}
                    >
                      <FontAwesomeIcon icon="fa-solid fa-arrow-up-right-from-square" />
                    </div>
                    <Tooltip    
                        className="tooltipStyles"
                        anchorSelect={"#tooltip-awslink"} 
                        content={"AWS Cloudwatch Dashboard oeffnen"} 
                        place="bottom" 
                        style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)", zIndex: "500" }}
                    />
                  </>
                ) : (
                  <>
                    <div
                      id={"tooltip-errordetails"}
                      className="singleGraph--HeaderToolBtn"
                      onClick={() => {
                        props.handleToggleSynmonAnalyse({
                          testID: props.testID,
                          productID: props.productID,
                          testName: props.testName,
                          productName: props.productName,
                          ok: props.thresholds.okay,
                          warn: props.thresholds.warn,
                          crit: props.thresholds.crit
                        });
                      }}
                    >
                      <FontAwesomeIcon icon="fa-solid fa-lightbulb" />
                    </div>
                    <Tooltip    
                        className="tooltipStyles"
                        anchorSelect={"#tooltip-errordetails"} 
                        content={"Fehler Screenshots und Analyse"} 
                        place="bottom" 
                        style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)", zIndex: "500" }}
                    />                 
                  </>
                )}
                <div
                  id={"tooltip-newticket"}
                  className="singleGraph--HeaderToolBtn"
                  onClick={() => {
                    openTicketWindow();
                  }}
                >
                  <FontAwesomeIcon icon="fa-solid fa-ticket" />
                </div>
                <Tooltip    
                    className="tooltipStyles"
                    anchorSelect={"#tooltip-newticket"} 
                    content={"Jira Ticket erstellen"} 
                    place="bottom" 
                    style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)", zIndex: "500" }}
                />                
                           
                <div id={"tooltip-detailinfo"} className={`singleGraph--HeaderToolBtn ${props.activeInfoGraph === graphKey ? 'singleGraph--HeaderToolBtn--active' : ''}`} onClick={() => {
                    // Wenn kein Detailwidget vorhanden ist: Hinweis anzeigen
                    if(!props.hasDetailWidget){
                      if(props.handleNotify){
                        props.handleNotify({type: 'info', message: 'Bitte zuerst das Detail-Widget hinzufügen (Menü > Graphdetail), um Detailinfos zu sehen.'});
                      }
                      return; // Keine weitere Aktion
                    }
                    if(props.setSelectedGraph){
                      // Produkt ID sicher mitgeben, damit Detailwidget korrekte ID (nicht Name) für Admin Aktionen hat
                      props.setSelectedGraph({ productName: props.productName, testName: props.testName, testID: props.testID, productID: props.productID, origin: props.origin });
                      if(props.handleNotify){
                        //props.handleNotify({type: 'success', message: 'Detailinformationen für den ausgewählten Graphen wurden im Detail-Widget angezeigt.'});
                      }
                    }
                    if(props.setActiveInfoGraph){
                      props.setActiveInfoGraph(graphKey);
                    }
                  }}><FontAwesomeIcon icon="fa-circle-info" /></div>
                <Tooltip    
                    className="tooltipStyles"
                    anchorSelect={"#tooltip-detailinfo"} 
                    content={"Detailinfos anzeigen"} 
                    place="bottom" 
                    style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)", zIndex: "500" }}
                /> 
                <div
                  id={"tooltip-deletegraph"}
                  className="singleGraph--HeaderToolBtn singleGraph--HeaderToolBtn--danger"
                  onClick={() => props.handleDeleteGraph(props.testID)}
                >
                  <FontAwesomeIcon icon="fa-solid fa-trash" />
                </div>
                <Tooltip
                    className="tooltipStyles"
                    anchorSelect={"#tooltip-deletegraph"}
                    content={"Graph entfernen"}
                    place="bottom"
                    style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)", zIndex: "500" }}
                />
                </div>
            </div>
            

            {
                (() => {
                    if (hasError === true)
                        return <div className="productWidget--ErrorWrap">Fehler beim Laden der Graphdaten.</div>
                    else if (isLoaded === false)
                        return(
                          <div className="productWidget--LoadingWrap">
                              <p className="productWidget--LoadingWrapText">Lade Daten</p>
                              <p><AppSpinner /></p>
                          </div> 
                        )
                    else 
                        return(
                          <HighchartsReact
                            highcharts={Highcharts}
                            constructorType={'stockChart'}
                            options={options}
                            allowChartUpdate={true}
                            // Flex-Child statt `height: 100%`:
                            // - `flex: 1` nimmt den Restplatz nach dem 45px-Header.
                            // - `minHeight: 0` erlaubt Shrinking unter Content-Größe,
                            //   sonst quetschen mehrere Graphen sich gegenseitig raus.
                            // - Highcharts misst dann den korrekt aufgelösten
                            //   Container-`offsetHeight` und das SVG passt exakt.
                            containerProps={{ style: { flex: 1, minHeight: 0 } }}
                          />
                        )
                })()
            }

            </div>
          
        </>    
    )

}

export default memo(SingleGraph) 